var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"material-icons-round",class:_vm.classes},[_c('v-icon',{staticClass:"material",attrs:{"color":_vm.config.color},domProps:{"textContent":_vm._s(_vm.config.icon)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }